import { useLocation } from "react-router-dom";

const PARAM = "from";

/** The current location as a path the next page can come back to. */
export function useCurrentPath(): string {
  const { pathname, search } = useLocation();
  return `${pathname}${search}`;
}

/**
 * Attach the path to return to. An explicit link, never history.back(): it
 * survives a refresh and a shared URL, and a page reached by URL alone simply
 * has no `from` and falls back to its default (MPN-1715).
 */
export function withReturnTo(path: string, from: string): string {
  const sep = path.includes("?") ? "&" : "?";
  return `${path}${sep}${PARAM}=${encodeURIComponent(from)}`;
}

/** The return path carried by the URL, if it is an in-app path. */
export function readReturnTo(search: string): string | null {
  const from = new URLSearchParams(search).get(PARAM);
  return from && from.startsWith("/") && !from.startsWith("//") ? from : null;
}
